enum Events {
  ActiveTrade = 'finance|active-trade',
  AccountModalOpen = 'vdp|account-modal|open',
  EstimatedAmountFinanced = 'finance|estimated-amount-financed',
  Geolocation = 'vdp|geolocation',
  GetStarted = 'vdp|get-started',
  HeaderAccountModalClose = 'header|account-modal|close',
  HeaderAccountModalOpen = 'header|account-modal|open',
  FinanceIsError = 'finance|is-error',
  FinanceIsLoading = 'finance|is-loading',
  IsTradeInApplied = 'finance|is-trade-in-applied',
  /**
   * @deprecated This will be removed in the next major version
   */
  SelectedFinanceTerm = 'finance|selected-finance-term',
  /**
   * @deprecated This will be removed in the next major version
   */
  TradeRequest = 'finance|trade-request',
  UserFinancing = 'finance|user-financing',
  UserProfile = 'vdp|user-profile'
}

export default Events;
